import { Button, Form, Modal, Select } from "antd";
import Input from "antd/es/input/Input";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { addStockSymbolValidator } from "../../../utils/addStockSymbolValidator";
import { addSymbolForImageVerification, setIsEditedForImageVerification, closeAddStockSymbolModalForImageVerification } from "../../../redux/ImageVerification/ImageVerificationAction";
import { validateISIN } from "../BrandQualityCheck/BrandQualityCheckHelpers";

type AddStockSymbolModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
  // currentStockSymbolIndex: number;
};

function AddStockSymbolModal(props: AddStockSymbolModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const stockDropdownData = useSelector((state: RootState) => state.imageVerificationState.brandDetailState.dropDownData.stockExchange);
  const stockSymbols = useSelector((state: RootState) => state.imageVerificationState.brandDetailState.data.stockSymbols);
 

  const AddStockSymbolContent = () => {
    const onFinish = (values: any) => {
      form.resetFields();
      dispatch(addSymbolForImageVerification({ ...values }));
      dispatch(setIsEditedForImageVerification(true));
      props.close();
    };

    return (
      <div className="d-flex flex-column justify-content-between gap-4 h-100 needs-validation">
        <h4>Add Stock Symbol</h4>
        <div className="d-flex flex-column gap-1">
          <div className="d-flex flex-column gap-2">
            <Form
              form={form}
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={onFinish}
              autoComplete="off"
              initialValues={{ remember: false }}
              colon={false}>
              <Form.Item
                label="Exchange"
                name="exchangeName"
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: "Please provide exchange.",
                  },
                ]}>
                <Select
                  placeholder="Please select exchange"
                  onChange={() => {
                    if (form.getFieldValue("symbol")) form.validateFields(["symbol"]);
                  }}>
                  {stockDropdownData.map((option) => (
                    <Select.Option
                      key={option.value}
                      value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              
              <Form.Item
                label={<span style={{ marginLeft: "10px" }}>ISIN</span>}
                name="isin"
                labelAlign="left"
                rules={[
                  {
                    
                    message: "Please provide ISIN.",
                  },
                  {
                    validator: validateISIN,
                  },
                ]}>
                <Input
                  placeholder="ISN"
                  onBlur={() => form.validateFields(["exchangeName"])}
                />
              </Form.Item>


              <Form.Item
                label="Symbol"
                name="symbol"
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: "Please provide symbol.",
                  },
                  {
                    validator(rule, value, callback) {
                      const ExchangeName = form.getFieldValue("exchangeName");
                      addStockSymbolValidator(rule, value, callback, stockSymbols, ExchangeName);
                    },
                  },
                ]}>
                <Input
                  placeholder="Symbol"
                  onBlur={() => form.validateFields(["exchangeName"])}
                />
              </Form.Item>

              <div className="d-flex gap-3 justify-content-end">
                <Button
                  className="saveButton"
                  type="primary"
                  htmlType="submit">
                  Add
                </Button>

                <Button
                  htmlType="reset"
                  onClick={() => {
                    props.close();
                  }}
                  // form="createNewFolderForm"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Modal
      //   width={FileUploadModalWidth}
      centered
      zIndex={1500}
      footer={[]}
      onCancel={() => dispatch(closeAddStockSymbolModalForImageVerification())}
      open={props.openState}>
      <AddStockSymbolContent />
    </Modal>
  );
}

export default AddStockSymbolModal;
